module.exports = __webpack_public_path__ + "img/paperwork-processed.f20cc2ba.svg";